import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useSessionTimeout } from '../hooks/useSessionTimeout';
import { SessionTimeoutModal } from './feedback';

interface SessionTimeoutProviderProps {
  children: React.ReactNode;
}

const SessionTimeoutProvider: React.FC<SessionTimeoutProviderProps> = ({ children }) => {
  const { logout } = useAuth0();
  const { showWarning, timeRemaining, extendSession, dismissWarning } = useSessionTimeout({
    warningTime: 5 * 60 * 1000, // Show warning 5 minutes before expiry
    // maxLifetime defaults to 12 hours since login, independent of
    // access-token expiry/refresh.
  });

  const handleLogout = () => {
    dismissWarning();
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <>
      {children}
      <SessionTimeoutModal
        isOpen={showWarning}
        timeRemaining={timeRemaining}
        onExtendSession={extendSession}
        onLogout={handleLogout}
      />
    </>
  );
};

export default SessionTimeoutProvider;
